import type { ReactElement } from 'react'

import './styles.scss'

const TooltipOverlay = (): ReactElement => {
  return (
    <div className="asset-tooltip-overlay">
      <div className="asset-tooltip-overlay__title emphasized-word">Advanced search:</div>
      <div className="asset-tooltip-overlay__content">
        <ul>
          <li>
            Prefix a word with <span className="emphasized-word">tk</span>: to search for a given tag-key
          </li>
          <li>
            Prefix a word with <span className="emphasized-word">tv</span>: to search for a given tag-value
          </li>
          <li>
            Prefix a word with <span className="emphasized-word">ft</span>: to search for a given file-type
          </li>
        </ul>
      </div>
      <div className="asset-tooltip-overlay__content">
        <div>Example:</div>
        <div>
          &quot;tk:learning_sampler tv:3.02.00 ft:image lifestyle&quot; would search for every image assets that have a
          tag-key &quot;learning_sampler&quot;, a tag-value &quot;3.02.00&quot;, and that contains &quot;lifestyle&quot;
          in their names.
        </div>
      </div>
    </div>
  )
}

export default TooltipOverlay
